import React, { useEffect, useState } from "react";

const PresentationSentencePanel = ({
  segment,
  segments,
  handlePreviousSegment,
  handleNextSegment,
}) => {
  const wordCount = segment?.words?.length || 0;
  const shouldAutoCollapse = wordCount < 15;

  const [expanded, setExpanded] = useState(!shouldAutoCollapse);

  useEffect(() => {
    setExpanded(!shouldAutoCollapse);
  }, [shouldAutoCollapse, segment?.id]);

  return (
    <section className="rounded-3xl border border-white/40 bg-white/80 backdrop-blur-sm shadow-lg shadow-slate-500/5 overflow-hidden">
      <div className="px-3 sm:px-4 py-3">
        <div className="flex items-center justify-between gap-3">
          <button
            type="button"
            onClick={handlePreviousSegment}
            disabled={segment?.id === 0}
            className={[
              "h-10 px-4 rounded-xl transition-all duration-200 flex items-center gap-2",
              segment?.id === 0
                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                : "bg-white/70 text-gray-700 hover:bg-white border border-white/40 hover:border-white/70 hover:shadow-md",
            ].join(" ")}
          >
            <span>←</span>
            <span className="text-sm font-medium">Previous</span>
          </button>

          <div className="flex items-center gap-3 min-w-0">
            <div className="text-sm font-semibold text-gray-900 whitespace-nowrap">
              Sentence {segments ? segment?.id + 1 : 0}/{segments?.length || 0}
            </div>

            <button
              type="button"
              onClick={() => setExpanded((v) => !v)}
              className="px-3 py-1.5 rounded-lg text-xs font-medium bg-white text-gray-700 hover:bg-gray-50 border border-gray-200 shadow-sm whitespace-nowrap"
            >
              {expanded ? "Hide text" : "Show text"}
            </button>
          </div>

          <button
            type="button"
            onClick={handleNextSegment}
            disabled={!segments || segment?.id >= segments.length - 1}
            className={[
              "h-10 px-4 rounded-xl transition-all duration-200 flex items-center gap-2",
              !segments || segment?.id >= segments.length - 1
                ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                : "bg-white/70 text-gray-700 hover:bg-white border border-white/40 hover:border-white/70 hover:shadow-md",
            ].join(" ")}
          >
            <span className="text-sm font-medium">Next</span>
            <span>→</span>
          </button>
        </div>
      </div>

      {expanded && (
        <div className="px-3 sm:px-4 pb-4">
          <div className="rounded-2xl border border-blue-200/30 bg-gradient-to-r from-blue-50/50 to-indigo-50/50 p-3">
            <div className="flex flex-wrap gap-2 justify-center">
              {segment?.words?.map((item, i) => (
                <span
                  key={`${segment?.id}-${i}`}
                  className="px-2.5 py-1.5 rounded-xl bg-white/80 border border-white/60 text-gray-800 text-base shadow-sm"
                >
                  {item.text}
                </span>
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default PresentationSentencePanel;